<div class="share-study-container" *ngIf="opened" (click)="close()">

  <div
    class="share-study-modal"
    role="dialog"
    aria-modal="true"
    (click)="$event.stopPropagation()">

    <div class="modal-header">

      <h3 class="modal-title">
        Compartir estudio con su médico
      </h3>

      <button
        class="close-btn"
        type="button"
        (click)="close()">

        <span class="material-icons">
          close
        </span>

      </button>

    </div>

    <div class="modal-divider"></div>

    <div class="modal-body">

      <p class="description">
        Para que su médico pueda visualizar el estudio, debe acceder desde su navegador a:
      </p>

      <!-- <a class="study-link" [href]="urlBase" target="_blank"> -->
      <a class="study-link">
        {{ urlReadable }}
      </a>

      <p class="description">
        e introducir el siguiente código localizador junto con el dato de verificación solicitado.
      </p>

      <div class="locator-container">

        <span class="locator-label">
          Localizador
        </span>

        <span class="locator-value">
          {{ locator }}
        </span>

      </div>

      <div
        class="instructions-box">

        <span>
          Puede pulsar el siguiente botón para copiar el enlace de acceso directo y enviarlo a su médico.
        </span>

        <button class="instructions-btn" (click)="copyURL()"> Copiar enlace directo </button>

      </div>

      <!--<div
        class="instructions-box"
        *ngIf="configService.config?.patient_download_instructions">

        <span>
          También puede descargar un documento con las instrucciones de acceso.
        </span>

        <button class="instructions-btn" (click)="downloadStudy()"> Descargar instrucciones </button>

      </div>-->
    </div>
  </div>

  <app-download-instructions></app-download-instructions>

</div>